<!-- APP CONTAINER -->
<div id="ContainerApp" [class]="appProperty.appStyleClass">
  @if (appProperty.loginPageNotVisible()) {
    <nav class="navbar navbar-light navbar-suite">
      <div class="navbar-brand tb-launch-group">
        <button id="appsIcon" type="button" aria-label="App" class="tb-launch appsIcon amSuiteDefault"
          (click)="op.toggle($event)">
          <i aria-hidden="true" class="pi pi-th-large"></i>
        </button>
        <span class="tb-brand">
          <label class="amSuiteDefault appFunctionLabel" for="appsIcon">{{appProperty.appFuctionName}}</label>
        </span>
        <button id="myButton" type="button" class="btn btn-primary showNotifyButton" (click)="showNotify()"
        disabled></button>
      </div>

      <span class="tb-spacer" aria-hidden="true"></span>

      <div class="text-white user-section">
        @if (sessionService.getSession && userProperty.userSelectedCompany) {
          <div class="topbar-actions">
            @if (appProperty.impersonateIsActive) {
              <div class="impersonate-actions">
                @if (innerWidth >= 1000) {
                  <p-button pRipple [loading]="impersonateLoader" icon="pi pi-user-minus"
                    label=" {{ 'account.remove-impersonate' | translate }}" styleClass="p-button-sm topbar-impersonate-btn"
                  (click)="removeImpersonate()"></p-button>
                }
                @if (innerWidth < 1000) { <p-button pRipple [loading]="impersonateLoader"
                  icon="pi pi-user-minus" styleClass="p-button-sm topbar-impersonate-icon-btn"
                  [pTooltip]="'account.remove-impersonate' | translate" tooltipPosition="top"
                  (click)="removeImpersonate()">
                </p-button>
              }
            </div>
          }

          <!-- OAuth Provider Box -->
          @if (appStateHolder.oauthState.providers.length > 0) {
            <div class="oauth-providers-box">
              @for (provider of appStateHolder.oauthState.providers; track provider.provider) {
                @if (provider.provider === 'Office365' || provider.provider === 'Microsoft') {
                  <div class="oauth-provider-item"
                    [class.oauth-active]="getOAuthProviderStatus(provider.provider) === 'active'"
                    [class.oauth-expiring]="getOAuthProviderStatus(provider.provider) === 'expiring'"
                    [class.oauth-expired]="getOAuthProviderStatus(provider.provider) === 'expired'"
                    [pTooltip]="provider.provider" tooltipPosition="top"
                    (click)="showOAuthPanel($event, provider.provider)">
                    <img src="assets/CustomIcons/microsoftprovider.svg" class="oauth-svg-icon-box microsoft-icon-box"
                      alt="" aria-hidden="true" width="18" height="18" />
                  </div>
                }
                @if (provider.provider === 'Jira' || provider.provider === 'Atlassian') {
                  <div class="oauth-provider-item"
                    [class.oauth-active]="getOAuthProviderStatus(provider.provider) === 'active'"
                    [class.oauth-expiring]="getOAuthProviderStatus(provider.provider) === 'expiring'"
                    [class.oauth-expired]="getOAuthProviderStatus(provider.provider) === 'expired'"
                    [pTooltip]="provider.provider" tooltipPosition="top"
                    (click)="showOAuthPanel($event, provider.provider)">
                    <img src="assets/CustomIcons/jiraprovider.svg" class="oauth-svg-icon-box jira-icon-box"
                      alt="" aria-hidden="true" width="18" height="18" />
                  </div>
                }
              }
            </div>
          }

          <div class="topbar-icon-actions tb-icons">
            <i class="pi pi-question-circle navActionIcon topbar-nav-icon icon-btn" role="button" tabindex="0"
            [attr.aria-label]="'app.support-button' | translate" (click)="visibleSupportSidebar = true"></i>
            @if (alertsCount > 0) {
              <!-- PrimeNG 22 ha rimosso la direttiva pBadge: il badge sovrapposto si ottiene
                   solo con <p-overlay-badge>, che avvolge l'elemento decorato. -->
              <p-overlay-badge [value]="alertsCount" severity="info">
                <i class="pi pi-bell navActionIcon topbar-nav-icon icon-btn" role="button" tabindex="0"
                  [attr.aria-label]="'app.alerts-button' | translate"
                (click)="visibleAlertSidebar = true"></i>
              </p-overlay-badge>
            }
            @if (alertsCount === 0) {
              <i class="pi pi-bell navActionIcon topbar-nav-icon icon-btn" role="button" tabindex="0"
              [attr.aria-label]="'app.alerts-button' | translate" (click)="visibleAlertSidebar = true"></i>
            }
            @if (showAIIcon) {
              <i class="pi pi-sparkles aiIcon topbar-nav-icon icon-btn" role="button" tabindex="0"
              [attr.aria-label]="'app.ai-assistant-button' | translate" (click)="visibleCopilotSidebar = true"></i>
            }
          </div>
        </div>
      }
      <div class="userInfo tb-user" role="button" tabindex="0" [attr.aria-label]="'app.user-profile-button' | translate"
        (click)="visibleSidebar = true">
        @if (sessionService.getSession && userProperty.userSelectedCompany) {
          <div class="userDefaultInfo who">
            <div class="username detail-user-bar">
              {{ sessionService.fullName }}
            </div>
            <div class="email">
              {{ sessionService.email }}
            </div>
            <div class="company-selected co">
              {{ userProperty.userSelectedCompany.name }}
            </div>
          </div>
          <span class="tb-avatar" aria-hidden="true">
            <i class="pi pi-user userDefaultIcon" aria-hidden="true"></i>
          </span>
        }
      </div>
    </div>
  </nav>
}

<div>
  <!-- sidebar -->
  @if (sidebarSrv.showSidebar) {
    <div>
      <app-sidebar></app-sidebar>
    </div>
  }

  <!-- OUTLET FOR COMPONENT -->
  <div [class]="sidebarSrv.showSidebar ? 'main-router-content' : 'no-sidebar-content'"
    [class.expanded]="sidebarSrv.isExpanded | async">
    @if (isNavigating()) {
      <div class="route-progress-bar" role="progressbar" [attr.aria-label]="'app.loading-page' | translate">
        <div class="route-progress-bar__track"></div>
      </div>
    }
    <router-outlet #outlet="outlet"></router-outlet>
  </div>
</div>

@if (appProperty.loadingData()) {
  <div class="spinneram">
    <div class="bounce1"></div>
    <div class="bounce2"></div>
    <div class="bounce3"></div>
    Caricamento...
  </div>
}
</div>

<p-toast appendTo="body" key="addWidgetFromApp"></p-toast>
<!-- Toast generico della shell: notifiche di widget, account e preferenze che non hanno
     un p-toast proprio (chiave unica, nessun altro p-toast usa 'appToast'). -->
<p-toast appendTo="body" key="appToast"></p-toast>
<!-- Avvio non riuscito: avviso fisso con «Riprova», che rilegge i dati della sessione. Il click
     su un toast lo chiude (dismissClickedToast), quindi «Riprova» chiude anche l'avviso. -->
<p-toast appendTo="body" key="startupError">
  <ng-template #message>
    <span class="p-toast-message-icon pi pi-exclamation-triangle" aria-hidden="true"></span>
    <div class="p-toast-message-text">
      <div class="p-toast-summary">{{ 'app.startup-error.title' | translate }}</div>
      <div class="p-toast-detail">{{ 'app.startup-error.detail' | translate }}</div>
      <p-button class="startup-error-retry" size="small" icon="pi pi-refresh"
        [label]="'app.startup-error.retry' | translate" (onClick)="retryLoadUserData()"></p-button>
    </div>
  </ng-template>
</p-toast>

<!-- Toast SENZA key: ospita i messaggi delle librerie @neworg-net renderizzate qui
     dentro (employee-causal-request-list, employee-competence-table nei
     dynamic-widgets), che dopo l'abbandono di ngx-toastr emettono su
     MessageService senza chiave. Senza questo p-toast keyless i loro messaggi
     verrebbero scartati in silenzio: nessun crash, nessun test rosso, toast
     invisibili. Gli altri p-toast dell'app hanno tutti una key, quindi nessuno
     di loro li intercetterebbe. -->
<p-toast appendTo="body"></p-toast>
<p-toast key="manageDash" appendTo="body"
(click)="appStateHolder.clearToasts()"></p-toast>

<user-menu [visible]="visibleSidebar" (close)="visibleSidebar = false"></user-menu>

<!-- PWA (SwUpdateService): avviso aggiornamento + recovery stato irrecuperabile. -->
<p-toast key="pwa" appendTo="body" [style]="{'z-index': '99999'}" [preventOpenDuplicates]="true"
  [breakpoints]="{'640px': {width: 'calc(100vw - 2rem)', right: '1rem'}}"></p-toast>
<p-confirm-dialog key="pwa-update" styleClass="pwa-update-dialog" appendTo="body" [draggable]="false"
  [style]="{width: '26rem', maxWidth: 'calc(100vw - 2rem)'}"
  [breakpoints]="{'640px': 'calc(100vw - 2rem)'}"></p-confirm-dialog>

<alert [visible]="visibleAlertSidebar" (alertsCount)="updateAlertsCount($event)" (close)="visibleAlertSidebar = false">
</alert>


@if (visibleCopilotSidebar) {
  <p-drawer [(visible)]="visibleCopilotSidebar" [position]="drawerPosition"
    [styleClass]="getSidebarClass()"
    (onHide)="visibleCopilotSidebar = null">
    <ng-template #header>
      <div class="copilotPanelHeader assist-head">
        <span class="assist-spark" aria-hidden="true">
          <i class="pi pi-sparkles sideBotIcon sideSparkleIcon"></i>
        </span>
        <span class="botTitle drawer-title">AmSuite Assistant</span>
      </div>
    </ng-template>
    <!-- <am-copilot [visible]="visibleCopilotSidebar" (close)="visibleCopilotSidebar = false"></am-copilot> -->
    <amsuite-assistant-bot #chatBot [bearerToken]="bearerToken" [dataOwnerId]="userProperty.userSelectedCompany?.id"
      [userModel]="sessionService.getSession" [idChat]="idChat" [userName]="sessionService.fullName" [source]="'amsuite'"
      presentation="embedded">
    </amsuite-assistant-bot>


  </p-drawer>
}

<support [visible]="visibleSupportSidebar" (close)="visibleSupportSidebar = false"></support>

<p-popover #op styleClass="app-menu" appendTo="body">
  <ng-template #content>
    <div class="launch-grid" role="menu" [attr.aria-label]="'app.app-menu-label' | translate">
      @for (app of userProperty.userSelectedCompany.apps; track $index) {
        <div class="appSelector launch-item" [class]="app.cssParams?.appClass || ''" role="menuitem" tabindex="0"
          [attr.aria-label]="('app.select-app' | translate:{ appName: app.functionName })"
          (click)="onSelectApp(app); op.hide()">
          <button type="button" [class]="app.cssParams.menuItemClass" class="launch-tile" aria-hidden="true" tabindex="-1">
            <i [class]="appIconClass(app)" aria-hidden="true"></i>
          </button>
          <label class="companyTruncate appName lab" [pTooltip]="app.functionName">{{app.functionName}}</label>
        </div>
      }
    </div>
  </ng-template>
</p-popover>

<p-popover #oauthPanel styleClass="oauth-status-panel" appendTo="body">
  <ng-template #content>
    @if (selectedOAuthProvider) {
      <div class="oauth-panel-content">
        <!-- Header con icona e nome provider -->
        <div class="oauth-panel-header">
          @if (selectedOAuthProvider === 'Office365' || selectedOAuthProvider === 'Microsoft') {
            <img src="assets/CustomIcons/microsoftprovider.svg" class="oauth-panel-svg-icon"
              alt="" aria-hidden="true" width="24" height="24" />
          }
          @if (selectedOAuthProvider === 'Jira' || selectedOAuthProvider === 'Atlassian') {
            <img src="assets/CustomIcons/jiraprovider.svg" class="oauth-panel-svg-icon"
              alt="" aria-hidden="true" width="24" height="24" />
          }
          <span class="oauth-provider-name">{{ selectedOAuthProvider }}</span>
        </div>
        <!-- Status content -->
        <div class="oauth-panel-status">
          @if (getOAuthProviderStatus(selectedOAuthProvider) === 'active') {
            <div class="oauth-status-item">
              <i class="pi pi-check-circle oauth-status-icon-active"></i>
              <div class="oauth-status-info">
                <div class="oauth-status-label">{{ 'oauth.active' | translate }}</div>
                <div class="oauth-status-expire">
                  {{ 'oauth.expiresOn' | translate }} {{ formatOAuthExpiryDate(selectedOAuthProvider) }} {{ 'oauth.at' |
                  translate }} {{ formatOAuthExpiryTime(selectedOAuthProvider) }}
                </div>
              </div>
            </div>
          }
          @if (getOAuthProviderStatus(selectedOAuthProvider) === 'expiring') {
            <div class="oauth-status-item">
              <i class="pi pi-exclamation-triangle oauth-status-icon-expiring"></i>
              <div class="oauth-status-info">
                <div class="oauth-status-label">{{ 'oauth.expiring' | translate }}</div>
                <div class="oauth-status-expire">
                  {{ 'oauth.expiresOn' | translate }} {{ formatOAuthExpiryDate(selectedOAuthProvider) }} {{ 'oauth.at' |
                  translate }} {{ formatOAuthExpiryTime(selectedOAuthProvider) }}
                </div>
              </div>
            </div>
          }
          @if (getOAuthProviderStatus(selectedOAuthProvider) === 'expired') {
            <div class="oauth-status-item">
              <i class="pi pi-times-circle oauth-status-icon-expired"></i>
              <div class="oauth-status-info">
                @if (formatOAuthExpiryDate(selectedOAuthProvider)) {
                  <div class="oauth-status-label">{{ 'oauth.expired' | translate }}</div>
                  <div class="oauth-status-expire">
                    {{ 'oauth.expiredOn' | translate }} {{ formatOAuthExpiryDate(selectedOAuthProvider) }} {{ 'oauth.at' |
                    translate }} {{ formatOAuthExpiryTime(selectedOAuthProvider) }}
                  </div>
                }
                @if (!formatOAuthExpiryDate(selectedOAuthProvider)) {
                  <div class="oauth-status-label">{{ 'oauth.notConfigured' | translate }}</div>
                }
              </div>
            </div>
          }
        </div>
        <!-- OAuth authorization button - always visible -->
        <div class="oauth-authorize-section">
          <p-button [raised]="true" [loading]="oauthAuthorizingProvider === selectedOAuthProvider"
            label="{{ 'oauth.authorize' | translate }}" styleClass="p-button-warning"
            (click)="authorizeOAuthProvider(selectedOAuthProvider); oauthPanel.hide()">
          </p-button>
        </div>
      </div>
    }
  </ng-template>
</p-popover>

